'use client'

import './Testimonials.css';
import { Testimonial } from './Testimonial';

import Slider from "react-slick";

const FormatSectionTestimonials = ( data: any, draftEnabled: boolean,  ) => {

  var settings = {
    dots: true,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const formattedTestimonialItems = data?.data?.testimonialItemsCollection?.items?.map((testimonial: any) => {
    return {
      quote: testimonial?.longQuote,
      attributionName: testimonial?.author,
      attributionQualification: testimonial?.qualification,
    }
  });

  return (
    <div className="mx-auto testimonials-section pr-10 pl-10 pb-10">
      {formattedTestimonialItems && formattedTestimonialItems.length > 1 && <Slider {...settings}>
        {formattedTestimonialItems.map((item:any, index:number) => {
          return <div key={index}><Testimonial {...item} /></div>
        })}
      </Slider>}
      {formattedTestimonialItems && formattedTestimonialItems.length == 1 &&
        <Testimonial {...formattedTestimonialItems[0]} />
      }
    </div>
  );
}
export default FormatSectionTestimonials;
